import LegalLayout, { Section } from "@/pages/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy">
      <p>
        This Privacy Policy explains how Gens Realty (&ldquo;we&rdquo;, &ldquo;us&rdquo;)
        collects, uses, and protects information you share with us — including through our
        AI receptionist Gentry (web chat and phone). We only use your information to help
        you with your real estate inquiry.
      </p>

      <Section heading="1. Information We Collect">
        <ul className="list-disc pl-5 space-y-1">
          <li>Name, phone number, and reason for contact when you fill out a form or speak with Gentry.</li>
          <li>The content of your chat and phone conversations with Gentry (stored as transcripts).</li>
          <li>Appointment date, time, and language preference.</li>
          <li>SMS consent status and the exact disclosure text you accepted, with a timestamp.</li>
        </ul>
      </Section>

      <Section heading="2. How We Use Your Information">
        <ul className="list-disc pl-5 space-y-1">
          <li>To respond to your inquiry and, when appropriate, connect you with a licensed agent.</li>
          <li>To confirm and follow up on appointments you request.</li>
          <li>To send you text messages only when you have explicitly opted in via the SMS consent checkbox (message frequency varies).</li>
          <li>To improve Gentry&apos;s language quality and service.</li>
        </ul>
      </Section>

      <Section heading="3. SMS Data &amp; No Sharing">
        <p>
          Text messaging opt-in data and consent records are <strong>not shared</strong>{" "}
          with any third party or affiliate for marketing purposes. Your phone number is
          used only to contact you regarding your Gens Realty inquiry.
        </p>
      </Section>

      <Section heading="4. How Long We Keep Your Data">
        <p>
          We retain inquiry data (name, phone, reason, transcripts, appointment details)
          for as long as needed to serve you and to comply with our record-keeping
          obligations as a Texas real-estate brokerage. You can request deletion at any
          time by emailing <a className="underline" href="mailto:hello@gensrealty.com">hello@gensrealty.com</a>.
        </p>
      </Section>

      <Section heading="5. Third-Party Processors">
        <p>
          To run the AI receptionist, we route your messages through carefully vetted
          service providers (Twilio for voice/SMS, Google/Anthropic/OpenAI for language
          models, Google Calendar for scheduling). Each provider processes data only to
          deliver the specific function we ask of them and is bound by their own privacy
          and security terms.
        </p>
      </Section>

      <Section heading="6. Your Choices">
        <ul className="list-disc pl-5 space-y-1">
          <li>Reply <strong>STOP</strong> to any text message to unsubscribe from SMS at any time.</li>
          <li>Ask us to update or delete your record by emailing hello@gensrealty.com.</li>
          <li>Decline to provide information — you can still browse our site and call us anytime.</li>
        </ul>
      </Section>

      <Section heading="7. Contact">
        <p>
          Gens Realty · Houston, TX
          <br />
          Phone: <a className="underline" href="tel:+13466992755">(346) 699-2755</a>
          <br />
          Email:{" "}
          <a className="underline" href="mailto:hello@gensrealty.com">
            hello@gensrealty.com
          </a>
        </p>
      </Section>
    </LegalLayout>
  );
}
